import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=999c41ac&"
import script from "./SuggestionList.vue?vue&type=script&lang=js&"
export * from "./SuggestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports